import { render } from "./judgmentEdit.vue?vue&type=template&id=1e0055fa"
import script from "./judgmentEdit.vue?vue&type=script&lang=js"
export * from "./judgmentEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__